<template>
  <q-dialog
    :visible="isVisible"
    title="编辑"
    width="600px"
    :innerScroll="false"
    :loading="loadingBtn"
    @close="onCancel"
    @cancel="onCancel"
    @confirm="onConfirm"
  >
    <el-form :model="form" :rules="rules" ref="ruleForm" label-width="150px" size="mini" v-loading="loading">
      <el-row>
        <el-col :span="24">
          <el-form-item label="商品编码:">{{form.goodsCode}}</el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="商品名称:">{{form.goodsName}}</el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="清仓销售价系数:" prop="clearancePrice">
            <el-select v-model="form.clearancePrice" filterable placeholder="请选择">
              <el-option :label="item.optionValue" :value="item.optionValue" v-for="item in optsList[0]" :key="item.id"></el-option>
              <el-option label="空" value=""></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </q-dialog>
</template>

<script>
export default {
  name: 'PriceUpholdEdit',
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    rowData: Object,
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
  },
  data() {
    return {
      loading: false,
      loadingBtn: false,
      optsList: [],
      form: {},
      rules: {}
    }
  },
  created() {
    this.initForm();
  },
  methods: {
    initForm() {
      this.loading = true;
      this.get_options(_ => {
        if (this.rowData) {
          this.$set(this.form, 'goodsCode', this.rowData['goodsCode']);
          this.$set(this.form, 'goodsName', this.rowData['goodsName']);
          this.$set(this.form, 'priceCoefficient', this.rowData['priceCoefficient']);
          this.$set(this.form, 'clearancePrice', this.rowData['clearancePrice']);
          this.$set(this.form, 'combinationPrice', this.rowData['combinationPrice']);
        }
        this.loading = false;
      });
    },
    onCancel() {
      this.isVisible = false;
    },
    onConfirm() {
      this.$refs['ruleForm'].validate((valid) => {
        if (!valid) return;
        this.loadingBtn = true;
        
        let data = { ...this.form };
        if (this.rowData && this.rowData['id']) {
          data['id'] = this.rowData['id'];
          this.modify(data);
        } else {
          this.add(data);
        }
      });
    },
    add(data) {
      this.$q.goods.goodsPriceCoefficientInsertData({ data })
        .then((res) => {
          if (res.code == 200) {
            this.$message.success('新增成功');
            this.isVisible = false;
            this.$emit('success');
          }
        })
        .finally(() => {
          this.loadingBtn = false;
        });
    },
    modify(data) {
      this.$q.goods.goodsPriceCoefficientUpdateById({ data })
        .then((res) => {
          if (res.code == 200) {
            this.$message.success('编辑成功');
            this.isVisible = false;
            this.$emit('success');
          }
        })
        .finally(() => {
          this.loadingBtn = false;
        });
    },
    // 获取下拉选项数据
    get_options(func) {
      let types = ['32'];
      this.request(types, 0, func)
    },
    request(types, index, func) {
      let data = {
        filterData: {
          optionType: types[index],
          tag: 2
        },
        pageNum: 1,
        pageSize: 1000,
      }
      if (!types[index]) {
        func();
        return false
      };
      this.$q.goods.listPage({ data })
        .then(res => {
          this.optsList.push(res.data.records)
          index++;
          this.request(types, index, func)
        })
    }
  }
}
</script>

<style lang="stylus" scoped>
</style>
